import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="text-[11px] md:text-xs tracking-[0.18em] uppercase text-charcoal/60"
    >
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-navy transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-navy" : ""}>{item.label}</span>
              )}
              {!isLast && <ChevronRight size={12} className="text-charcoal/40" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
